import Utils from '@/core/utils/Utils';
import ProductionSitesDAO from '@/domains/ProductionSites/ProductionSitesDAO';
import ProductionSite from '@/domains/ProductionSites/ProductionSite';
import Partner from '@/domains/Partners/Partner';
import Company from '@/domains/Companies/Company';

/**
 * Сервис производственных площадок
 */
class ProductionSitesService {

    /**
     * Загружает площадку по id
     */
    static async get(id: string): Promise<ProductionSite | null> {
        const response = await ProductionSitesDAO.get(id);
        return Utils.hydrate(response.data, ProductionSite.fromServer);
    }

    /**
     * Загружает список площадок
     */
    static async getList(
        partner?: Partner | null,
        company?: Company | null
    ): Promise<ProductionSite[]> {
        const response = await ProductionSitesDAO.getList(
            partner?.id ?? null,
            company?.id ?? null
        );
        return Utils.hydrateArray(response.data, ProductionSite.fromServer);
    }
}

export default ProductionSitesService;